import styled from 'styled-components';
export var Blur = styled.div.withConfig({
  displayName: "style__Blur",
  componentId: "sc-1yct9mw-0"
})(["position:absolute;top:0;left:-15px;width:", ";height:", ";background-color:rgba(255,255,255,0.7);z-index:9999999999;overflow:hidden;visibility:", ";"], function (props) {
  return props.width ? "".concat(props.width, "px") : '110%';
}, function (props) {
  return props.height ? "".concat(props.height, "px") : '100%';
}, function (props) {
  return props.visibility ? "visibile" : 'hidden';
});
export var PlotContainer = styled.div.withConfig({
  displayName: "style__PlotContainer",
  componentId: "sc-1yct9mw-1"
})(["color:white;height:420px;"]);
export var SpinnerBox = styled.div.withConfig({
  displayName: "style__SpinnerBox",
  componentId: "sc-1yct9mw-2"
})(["color:red;width:70px;position:relative;margin:auto;float:left;top:50%;left:50%;transform:translate(-50%,-50%);"]);